import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-users-status-cell-renderer',
  template: `
    <span
      [class]="badgeClass"
      (click)="onToggleStatus()"
      [title]="getTooltip()"
      [style.cursor]="isCurrentUser ? 'not-allowed' : 'pointer'"
      [style.opacity]="isCurrentUser ? '0.7' : '1'">
      {{ status }}
    </span>
  `,
})
export class StatusCellRendererComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams;
  status!: string;
  badgeClass!: string;
  isCurrentUser: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.updateStatus();
    this.checkIfCurrentUser();
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.updateStatus();
    this.checkIfCurrentUser();
    return true;
  }

  private updateStatus(): void {
    const isActive = this.params.value;
    this.status = isActive ? 'Active' : 'Inactive';
    this.badgeClass = isActive ? 'badge badge-success' : 'badge badge-secondary';
  }

  private checkIfCurrentUser(): void {
    try {
      const userProfileData = localStorage.getItem('userProfile');
      if (userProfileData) {
        const userProfile = JSON.parse(userProfileData);
        const currentUserId = userProfile.id;
        this.isCurrentUser = this.params.data && this.params.data.id === currentUserId;
      }
    } catch (error) {
      console.error('Error checking current user:', error);
      this.isCurrentUser = false;
    }
  }

  getTooltip(): string {
    if (this.isCurrentUser) {
      return 'You cannot change your own status';
    }
    return 'Click to toggle status';
  }

  onToggleStatus(): void {
    if (this.isCurrentUser) {
      return; // Do nothing if it's the current user
    }
    if (this.params.context && this.params.context.toggleStatus) {
      this.params.context.toggleStatus(this.params.data);
    }
  }
}